import { removeNull } from '@/utils/handleData'

export default {
  namespaced: true,
  state: {
    manageEvaluationList: {}, // 考评列表
    totalEvaluationScore: 0, // 列表查询合计考评分
    currentSubjectScore: 0, // 某考评对象合计考评分
    personEvaluation: {}
  },
  actions: {
    // 获取考评列表
    async getManageEvaluationList(
      { state, rootState, commit, dispatch },
      data
    ) {
      if (!data) {
        await dispatch(
          'bidSection/ensureDefaultBidQuery',
          { queryKey: 'manageEvaluation', fieldKey: 'orgUid' },
          { root: true }
        )
      }
      var queryValues = {
        orgUid: data
          ? data.orgUid
          : rootState.queryValues.manageEvaluation.orgUid,
        subjectUid: data
          ? data.subjectUid
          : rootState.queryValues.manageEvaluation.subjectUid,
        eventType: data
          ? data.eventType
          : rootState.queryValues.manageEvaluation.eventType,
        subjectName: data
          ? data.subjectName
          : rootState.queryValues.manageEvaluation.subjectName,
        page:
          data && data.page
            ? data.page
            : rootState.page.manageEvaluation
            ? rootState.page.manageEvaluation
            : 1,
        limit:
          data && data.limit
            ? data.limit
            : rootState.limit.manageEvaluation
            ? rootState.limit.manageEvaluation
            : 10
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/scorelist',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      var manageEvaluationList =
        res.data && res.data.pageData ? res.data.pageData : {}
      var totalEvaluationScore =
        !data && res.data && res.data.totalScore
          ? res.data.totalScore
          : state.totalEvaluationScore
      var currentSubjectScore =
        data && res.data && res.data.totalScore ? res.data.totalScore : 0
      if (manageEvaluationList.result) {
        manageEvaluationList.result.forEach((item) => {
          item.disabledButtons = []
          if (item.orgUid !== rootState.user.orgValue) {
            item.disabledButtons = ['', 1, 2]
          }
          item.integralType =
            item.score > 0
              ? '奖分'
              : item.eventType === '积分兑换'
              ? '兑换'
              : '扣分'
        })
        if (!data && rootState.queryValues.manageEvaluation.integralType) {
          manageEvaluationList.result = manageEvaluationList.result.filter(
            (item) => {
              return (
                rootState.queryValues.manageEvaluation.integralType ===
                item.integralType
              )
            }
          )
        }
      }
      commit(
        'baseSet',
        {
          module: 'manageEvaluation',
          key: 'totalEvaluationScore',
          value: totalEvaluationScore
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'manageEvaluation',
          key: 'currentSubjectScore',
          value: currentSubjectScore
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'manageEvaluation',
          key: 'manageEvaluationList',
          value: manageEvaluationList
        },
        { root: true }
      )
    },
    // 新增考评事项
    async addManageEvaluation({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/score',
          data: data,
          msg: data.msg ? data.msg : '新增考评事项成功'
        },
        { root: true }
      )
      return res
    },
    // 获取个人考评
    async getPersonEvaluation({ commit, dispatch }) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/score'
        },
        { root: true }
      )
      //console.log(res)
      var personEvaluation = res.data ? res.data : {}
      commit(
        'baseSet',
        {
          module: 'manageEvaluation',
          key: 'personEvaluation',
          value: personEvaluation
        },
        { root: true }
      )
      return personEvaluation
    },
    // 编辑考评事项
    async editManageEvaluation({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/cultivate/score',
          data: data,
          msg: '编辑考评事项成功'
        },
        { root: true }
      )
      return res
    },
    // 删除考评事项
    async deleteManageEvaluation({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/cultivate/score',
          data: { uid: uid },
          msg: '删除考评事项成功'
        },
        { root: true }
      )
      return res
    }
  }
}
